export enum LaunchpadSource {
  DashboardLaunchpadBanner = "Dashboard Launchpad Banner",
  TopNavBar = "Top Nav Bar",
  LaunchpadFullScreen = "Launchpad full screen",
}

export enum LaunchpadStepAction {
  Viewed = "Viewed",
  Skipped = "Skipped",
  Completed = "Completed",
}

export enum LaunchpadTask {
  SetBookkeepingPlan = "Set your bookkeeping plan",
  SetTaxPlan = "Set your tas plan",
  VerifyBankBalances = "Verify your opening balances",
  RreviewCategorizeTransactions = "Review & categorize transactions",
  StartHistoricalTransferProcess = "Start your historical accounting data transfer",
  ReviewVariancesWithSpotlight = "Review variances with Spotlight",
  ReviewMonthlyCloseChecklist = "Review your monthly close checklist",
  InviteYourTeam = "Invite your team",
  ConnectFinancialAccounts = "Connect all of your financial accounts",
  GetPuzzleCertified = "Get Puzzle Certified",
  ConfigureYourAccountingSettings = "Configure your accounting settings",
  CustomizeChartOfAccounts = "Customize your chart of accounts",
  ConfigureClassesAndDepartments = "Configure your classes & departments",
  CreateCustomRules = "Create your custom rules",
  CreateRevenueRecognitionPolicies = "Create your revenue recognition policies",
  InviteFirmsTeamMembers = "Invite your firm's team members",
  InviteClientsToConnectFinancialAccounts = "Invite your clients to connect financial accounts",
  ConfigureAutomationSettings = "Configure your automation settings",
  ReviewTransactions = "Review & categorize your transactions",
  CompleteBrexConnection = "Complete Brex connection",
}
